<template>
	<!-- 公共头部 -->
	<div class="common black">
		<div class="header">
			<img src="../assets/images/logo.png" alt="" class="logo">
			<ul class="bannerList">
				<li v-for="(item,index) in topList" :key="index" @click="toggle(index)" >
					<router-link :to="{name:item.name}">{{item.title}}</router-link>
				</li>   
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				topList:[
					{title:'网站首页',name:'Index'},
					{title:'解决方案',name:'Solution'},
					{title:'智能硬件',name:'Product'},
					{title:'软件定制',name:'Software'},
					{title:'项目案例',name:'Case'},
					{title:'关于我们',name:'About'},
					{title:'联系我们',name:'Contact'},
				]
			}
		},
		methods:{
		}
	}
</script>

<style lang="scss" scoped>
	.sangle{
		color: #3C77F0;
	}
	.black{
		background: #000000;
	}
	.header{
		width: 1200px;
		height: 70px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		.bannerList{
			display: flex;
			flex-direction: row;
			color: #fff;
			font-size: 14px;
			li{
				padding: 0 8px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/header.vue